define([
	"dojo/_base/declare",
	"csi",
	"csi/table/Widget"
], function(declare,csi,Widget) {

	return declare(Widget, {
		loadPlugins: function() {
			//Summary: Do not display the toolbar "Sort order" actions for a linked Sales Collection or a SMLook.
			var	dfd = this.inherited(arguments);

			var node = this.getViewNode();
			if (node && (node.MasterCollection != csi.EMPTY_URL)) {
				this.toolbarNode.removePlugins(["tableRemoveSort","tableApplySort"]);
			}
			
			return dfd;
		}
	});
});